import { isFormTypeValid } from "../../util/functions";

export const parseType = (row) => {
    const { type: _type, sk } = row;
    let type = (_type || "").toLowerCase();
    const [formTypeFromSk] = (sk || "").split("#") || [];
    let isValidFormType = isFormTypeValid(type);
    if (!isValidFormType && isFormTypeValid(formTypeFromSk)) {
      type = formTypeFromSk;
      isValidFormType = true;
    }
    if (!isValidFormType) {
      return ""
    }
    return type
  }

function parseBackendToClientFriendlyForms(forms = []) {
  if (!Array.isArray(forms) || !forms?.length) {
    return [];
  }
  const normalized = forms.map((row) => {
    const identifierFromSk = (row?.sk || "").split("#")?.[1];
    const id = row?.id || identifierFromSk;
    return {
      ...row,
      id,
      type: parseType(row)
    };
  });
  return normalized.filter(
    ({ id, type }) => !!id && type
  );
}

export { parseBackendToClientFriendlyForms };
